<template>
  <div v-if="!vertical" class="data">
    <span class="label">{{name}}</span>
    <span class="number">
      <span v-if="!isNaN(value) || (typeof value ===`string`)">{{value}}</span>
      <span class="disabled" v-else>--</span>
      <span class="color" color></span>
    </span>
  </div>
  <div v-else-if="!isNaN(value) || (typeof value ===`string`)" class="data" vertical>
    <span :disabled="isNaN(value)" class="label">{{name}}</span>
    <span class="number">
      <span>{{value}}</span>
      <span class="color" color></span>
    </span>
  </div>
</template>

<script>
export default {
  name: "MoleculeCardProp",
  props: {
    name: String,
    value: [Number, Boolean, String],
    vertical: Boolean
  }
};
</script>

<style scoped>
.data {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 45%;
  margin-left: 0.6rem;
}

.data .label {
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.32px;
  color: #565656;
  margin-top: 0.5rem;
  margin-bottom: 0.25rem;
}

.data .label[disabled] {
  color: #8c8c8c;
}

.data .number {
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  color: #171717;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.16px;
}

.data .number .color {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-left: 0.5rem;
}

.number .disabled {
  color: #8c8c8c;
}

.data .number .color[color="red"] {
  background: #fb4b53;
}

.data .number .color[color="blue"] {
  background: #4589ff;
}
</style>
